import { unAllowedJobsToAbort } from "./common-utils";

/**

Messages shared with components.

*/
export const Messages = {
    /**
     * Text or label for the refresh icon/button, save, cancel button.
     */
    refreshIcon: 'Refresh',
    tooltip: 'Utilization data of license',
    saveIcon: 'Save',
    cancelIcon: 'Cancel',
    editIcon: 'Edit',
    deleteIcon: 'Delete',
    success: 'Success',
    update: 'Updated',
    error: 'Error',
    failed: 'Failed',
    unknownErr: 'Unknown error occurred !',
    moreDetails: 'More details',
    editToolTip: 'Edit',
    wfRunCompName: 'Workflows / Workflow-run',
    gitWfExecCompName: 'GitHub workflows / execute',
    /**
     * Messages displayed in the AccessComponent.
     * Success message.
     * Success message for access update.
     * Failure message.
     * Failure message for access update.
     * Information message when no data is modified.
     * Information message to modify access before saving.
     */
    access: {
        success: 'Success',
        accessUpdated: 'Access updated successfully!',
        failed: 'Failed',
        updateFailed: 'Failed to update access!',
        noDataModified: 'No data modified',
        modifyAccess: 'Please modify access before saving'
    },
    statusDistribution: {
        title: "Workflow status distribution"
    },
    /**
     * Title text for the confirmation dialog when editing an item.
     * Title text for the confirmation dialog when deleting an item.
     * Confirmation message displayed when confirming an edit action.
     * Confirmation message displayed when confirming a delete action.
     * Confirmation message displayed when confirming an update action.
     * Title text for the confirmation dialog when updating an item.
     */
    confirmDialog: {
        title: {
            update: 'Update',
            edit: 'Edit',
            delete: 'Delete'
        },
        msg: {
            update: 'Are you sure you want to update?',
            edit: 'Are you sure you want to edit?',
            delete: 'Are you sure you want to delete this?'
        }
    },
    /**
     * Error message displayed when a configuration name is required.
     * Error message displayed when the configuration name exceeds the maximum character limit.
     * Error message displayed when an invalid configuration name is entered.
     * Error message displayed when no workflow is selected during configuration creation.
     */
    addConfigNew: {
        cfgName: {
            required: 'Enter configuration name',
            maxLength: 'Maximum length is 150 characters only',
            invalid: 'Not a valid name'
        },
        wfValidation: 'Choose at least one workflow',
    },
    /**
     * Placeholder text or label for the argument type selection field.
     */
    argumentCard: {
        argType: 'Choose argument type'
    },
    /**
     * Success message displayed when an operation is successfully executed.
     * Error message displayed when an operation fails.
     * Success message displayed when the priority of a workflow is successfully updated.
     * Error message displayed when the priority update of a workflow fails.
     * CSS class for displaying a high priority workflow.
     * CSS class for displaying a medium priority workflow.
     * CSS class for displaying a low priority workflow.
     * CSS class for displaying the default priority of a workflow.
     * CSS class for displaying the queued status of a workflow.
     * CSS class for displaying the in-progress status of a workflow.
     * CSS class for displaying the default status of a workflow.
     */
    qMngrExpandCfg: {
        successMsg: 'Operation successful',
        errorMsg: 'Operation failed',
        priority: {
            updated: 'Workflow priority updated successfully!',
            updateFailed: 'Workflow priority failed to update!',
            high: 'alert-danger',
            medium: 'alert-warning',
            low: 'alert-success',
            default: 'alert-info',
        },
        abortWorkflowJob: {
            aborted: 'Workflow aborted successfully!',
            abortFailed: 'Workflow failed to abort!',
            abortNotAllowed: unAllowedJobsToAbort.join(', ').replace(/,(?!.*,)/, ' and') + " jobs are not allowed to abort",
        },
        status: {
            queued: 'alert-warning',
            inprogress: 'alert-inprogress',
            dispatched: 'alert-info',
            default: 'alert-info',
        }
    },
    /**
     * Error message displayed when a value is required between 0 and 100.
     * Error message displayed when an invalid threshold value is entered.
     */
    tableEditable: {
        thresholdMsg: {
            required: 'Enter value between 0-100',
            thresholdValue: 'Not a valid value',
        }
    },
    /**
     * Error message displayed when a repository name is required.
     * Error message displayed when an invalid repository name is entered.
     * Error message displayed when an invalid URL is entered.
     *
     */
    triggerArtifact: {
        repoRequired: 'Enter a repo name',
        repoInvalid: 'Not a valid repo name',
        required: 'You must enter a value',
        invalid: 'Not a valid url'
    },

    /***
     * Error message displayed when a tool name is required.
     * Error message displayed when a invalid tool name is entered.
     * Error message displayed when a tool version is required.
     * Error message displayed when a tool type is required.
     * Error message displayed when a tool os is required.
     * Error message displayed when a tool count is required.
     * Error message displayed when a invalid tool count is entered.
     * Success message
     * Confirmation message displayed
     */
    addTool: {
        toolNmReq: 'Please enter tool name.',
        toolPattern: 'Special characters are not allowed.',
        toolVer: 'Please enter tool version.',
        toolType: 'Please enter tool type.',
        toolOs: 'Please enter tool operating system.',
        toolCntReq: 'Please enter available count.',
        toolCntPattern: 'Please enter a positive integer value.',
        success: 'success',
        error: 'Error',
        toolAdd: 'Tool added successfully!',
        toolFail: 'Failed to save tool!',
        toolUpdate: 'Tool updated succeSsfully!',
        toolUpdFail: 'Failed to update tool!',
        toolDel: 'Tool deleted successfully!',
        toolTypeInput: 'Please enter floating license name.',
        ipAddr: 'Please enter ip address.',
        ipAddrPattern: 'Please enter a valid ip address.',
        minCnt: 'Please enter minimum count.',
        minCntAvail: 'The minimum count should be less than available count.',
        minCntPattern: 'Please enter a positive integer value.',
        nameInput: 'Name is required',
        duplicateName: 'Name must be unique',
    },
    /**
     * Success message when floating license is successfully added
     * Failure message when floating license is failed to add
     */
    fltLicSrv: {
        fltLicAdd: 'Floating license details added successfully',
        fltLicAddErr: 'Failed to add floating license details',
    },
    /**
     * Success message when integrated workflow is successfully added
     * Failure message when integrated workflow is failed to add
     */
    integratedWf: {
        cfgSuccess: 'Configuration saved successfully !',
        cfgFail: 'Failed to save the configuration !',
        wfConFail: 'Connection to workflow service failed !',
        cfgUpdated: 'Configuration updated successfully !',
        cfgUpdFail: 'Failed to update the configuration !'
    },
    /**
     * Access denied message if the user does not have the access to UI
     */
    accessDeniedMsg: {
        title: "Access restricted",
        content: "You do not have the necessary permissions to access this resource. Please contact your administrator for assistance or request the appropriate role to gain access."
    },
    /**
     * Manual wf trigger
     */
    manualWfTrigger: {
        triggerSuccess: 'Workflow added to queue successfully !',
        triggerFail: 'Workflow failed to queue !',
        wfStatusChangeSuccess: 'Workflow status changed successfully !',
        wfStatusChangeFail: 'Workflow status change failed !',
        reRunSuccess: 'Workflow rerun successful !',
        reRunFail: 'Workflow rerun failed !',
    },

    externalLinksMsgs:{
        fetchAllLinksSuccess:'Data fetched successfully!',
        fetchAllLinksFail:'Failed to fetch the data!',
        addedSuccessfully:'New Link added successfully!',
        failedToAdd:'Failed to add new link!',
        updatedSuccessfully:'Link updated successfully!',
        failedToUpdate:'Failed to update link!',
        deletedSuccessfully:'Link deleted successfully!',
        uploadSuccessful: 'Image upload/update successful!',
        uploadFail: 'Image upload/update failed!',
        deleteImgSuccess: 'Image deleted successfully',
        deleteImgFail: 'Image delete failed!',
        failedToDelete:'Failed to delete link!',
        activeFail:'Error while adding new link and checking active records',
        activeLinkError:'Error while adding new link and checking active records',
        activeSeqNum: 'Active links can only contain sequence number',
        uploadLimit: 'File size exceeds maximum limit 1 MB',
        uploadType: 'Only JPG, JPEG, PNG, and SVG files are supported',
    },
    /** addDetailsNew*/
    addDetailsNew: {
        nameValidation: {
            required: 'Enter External Link name',
            invalidFormat: 'Invalid input format',
            invalid: 'Not a valid name'
        },
        descValidation: {
            required: 'Enter link related description',
            invalidFormat: 'Invalid input format',
            invalid: 'Not a valid description'
        },
        urlValidation: {
            required: 'Enter a valid URL',
            invalid: 'Not a valid URL'
        },
        extLabelValidation: {
            required: 'Select a valid label',
        },
    },
    /**
     * Workflow run page
     */
    wfRun: {
        worktkt: 'Workticket unavilable',
        openGitAction: 'Open GitHub action',
        reRunWf: 'Rerun workflow',
    },

    dashboard:{
        testMetricsTitle:'Test Wing 4- ITCG Test Execution Metrics',
        timelineChartTitle:'ITCG Timeline Chart',
        temporalGraphTitle:'ITCG-Temporal Graph',
        dataParsingTitle:'Data Parsing Report',
        tfrpTitle:'TFRP',
        tfrpTimelineTitle:'TFRP Timeline Chart'
    },

    issueTmplate: {
        getissueTmpFail: 'Failed to fetch issue template list',
        getissueTmpInpFail: 'Failed to fetch issue template inputs',
    },

    QGCheck: {
        QGCheckStatus: 'QG Check Status',
        QGCheckStatusMsg: 'The QG Check status is already ',
        QGCheckUpdateSuccess: 'QG Check status updated successfully!',
        QGCheckUpdateFail: 'Failed to update QG Check status!'
    },

    GitSync: {
        RepoLoadFail: 'Failed to load repositories!',
        issueTmplLoadSuccess: 'Issue template loaded successfully!',
        issueTmplLoadFail: 'Failed to load issue template!',
        SyncSuccess: 'Synchronization successful!',
        SyncFail: 'Synchronization failed!',

    },

    /**
     * Dependent checks messages for dependency graph validation and operations
     */
    dependentChecks: {
        // Dependency graph connection validation messages
        graph: {
            redundantBefore: 'Cannot create connection to {nodes}: These nodes are already reachable through other selected targets. Direct connection would be redundant.',
            redundantAfter: 'Cannot create connection from {nodes}: "{newNode}" will already depend on these nodes through other selected sources. Direct connection would be redundant.',
            cycleCreate: 'Cannot create connection: {connection} would form a cycle.',
            redundantIndirectPath: 'Cannot save: Connection {connection} is redundant because "{sourceName}" already has a indirect path to "{targetName}".',
            redundantCommonAncestor: 'Cannot save: Connection {connection} is redundant because "{ancestorName}" already connects to both.',
            isBlockingTooltip: 'ON: If this configuration fails, child executions will be skipped. OFF: Child executions will proceed regardless of this configuration\'s result.',
            blockingLegendTooltip: 'If this configuration fails, child executions will be skipped',
            nonBlockingLegendTooltip: 'Child executions will proceed regardless of this configuration\'s result',
            deletedTooltip: 'This configuration has been deleted. Please remove it from the graph.',
            inactiveTooltip: 'This workflow configuration is inactive. Please reactivate it from the workflow configuration page.',
            nonBlockingDisabledTooltip: 'Nodes without outgoing connections are always non-blocking'
        },
        // Save button tooltips
        save: {
            hasDeletedOrInactive: 'Remove deleted or inactive configurations from the graph before saving',
            formInvalid: 'Please fill in all required fields',
            noConfigurations: 'Add configurations to graph before saving',
            ready: 'Save the current dependency configuration'
        },
        // Configurations card tooltips
        configurations: {
            loadDisabled: 'Please fill in Repo Pattern, Event, and Action fields',
            loadEnabled: 'Load configurations based on your input filters',
            alreadyInGraph: 'Already in graph',
            addToGraph: 'Click to add to graph'
        },
        // Action field messages
        actions: {
            noActionsAvailable: 'No actions available for selected event',
            pushEventNoActions: 'Push events do not require actions'
        },
        // Confirmation dialog for input changes in edit mode
        confirmInputChange: {
            title: 'Confirm Input Change',
            message: 'Changing inputs will reset graph and workflow configurations. Do you want to continue?'
        },
        // Toast messages for CRUD operations
        toast: {
            common: {
                networkError: 'Network error occurred. Please check your connection and try again.'
            },
            save: {
                successTitle: 'Configuration saved successfully',
                successBody: 'Your dependent check configuration has been saved.',
                errorTitle: 'Failed to save configuration',
                errorInvalidResponse: 'Invalid server response. Please try again.'
            },
            update: {
                successTitle: 'Configuration updated successfully',
                successBody: 'Your dependent check configuration has been updated.',
                errorTitle: 'Failed to update configuration',
                errorNotUpdated: 'Configuration was not updated. Please try again.'
            },
            delete: {
                successTitle: 'Configuration deleted successfully',
                successBody: 'The dependent check configuration has been deleted.',
                errorTitle: 'Failed to delete configuration'
            },
            load: {
                errorTitle: 'Failed to load configuration',
                errorBodyEdit: 'Could not load configuration details for editing. Please try again.',
                errorBodyView: 'Could not load configuration details. Please try again.'
            }
        },
        noData: 'No data available'
    },
    /**
     * Messages for Workflow Execution History Component
     */
    workflowExecutionHistory: {
        invalidResponse: 'Invalid response format from server',
        fetchError: 'Error fetching workflow history'
    },
    /**
     * Messages for Dynamic Configuration page
     */
    dynamicConfig: {
        successMsg: 'Success',
        infoMsg: 'Info',
        errorMsg: 'Error',
        cancel: {
            dialogTitle: 'Cancel Configuration Run',
            dialogMessage: 'Are you sure you want to cancel this run? This action cannot be undone.',
            tooltip: 'Cancel all the jobs of this configuration',
            success: 'Configuration run cancelled successfully.',
            noJobsToAbort: 'There are no jobs to abort for this configuration run.',
            failed: 'Failed to cancel the configuration run. Please try again.',
            requestedTitle: 'Cancellation request received',
            requested: 'Jobs are being aborted in the background. Please refresh after 5 minutes to verify the status.',
        },
        redispatch: {
            tooltip: 'Redispatch workflow job',
            success: 'Workflow job dispatched successfully.',
            notAcceptable: 'Workflow job cannot be dispatched.',
            failed: 'Failed to redispatch the workflow job. Please try again.',
        },
        executionDetails: {
            refreshTooltip: 'Refresh execution details',
        },
        loadFailed: 'Failed to load data. Please try again.',
        noData: 'No data available',
    },
    /**
     * Messages for the Labels admin page
     */
    labels: {
        success: 'Success',
        failed: 'Failed',
        loadFailed: 'Failed to load labels.',
        addSuccess: 'Label added successfully.',
        updateSuccess: 'Label updated successfully.',
        addFailed: 'Failed to add label.',
        updateFailed: 'Failed to update label.',
        deleteSuccess: 'Label deleted successfully.',
        deleteFailed: 'Failed to delete label.'
    },

    /**
     * Messages for HIL Test Results Upload page
     */
    hilUpload: {
        fileEmpty: 'File is empty. Please select a valid ZIP file.',
        invalidExtension: 'Only .zip files are allowed.',
        noApprovedNames: 'No approved file names configured. Please contact administrator.',
        invalidFileName: 'Invalid file name. Hover the info icon to view the approved file names.',
        uploadFailed: 'Failed to upload HIL test results file. Please try again.',
        actionReadyToUpload: 'Ready to upload 1 validated file',
        actionSelectToBegin: 'Select a ZIP file to begin',
        progressUploading: 'Uploading to Artifactory...',
        progressReady: 'Valid file selected — click Upload to continue',
        progressWaiting: 'Waiting for a valid file selection',
        stepTransferring: 'Transferring package',
        stepNoUpload: 'No upload in progress'
    },

    /**
     * Messages for Scheduler page (titles, tooltips, toasts, confirm dialog and form validation)
     */
    scheduler: {
        listTitle: 'Scheduled Jobs',
        createTitle: 'Schedule a Job',
        createTooltip: 'Create a new scheduled workflow job',
        runOnceTooltip: 'Run once job (no CRON expression)',
        noData: 'No schedules available.',
        noChanges: 'No changes to update.',
        noWorkflowInputs: 'This workflow has no inputs to configure.',
        loadFailed: 'Failed to load schedulers.',
        loadDetailsFailed: 'Failed to load scheduler details.',
        loadWorkflowsFailed: 'Failed to load workflow names.',
        loadInputsFailed: 'Failed to load workflow inputs.',
        loadExecutionsFailed: 'Failed to load execution details.',
        create: { success: 'Scheduler scheduled successfully.', failed: 'Failed to schedule job.' },
        update: { success: 'Scheduler updated successfully.', failed: 'Failed to update scheduler.' },
        delete: {
            success: 'Scheduler deleted successfully.', failed: 'Failed to delete scheduler.',
            title: 'Delete Scheduler', confirm: 'Are you sure you want to delete this scheduler?'
        },
        validation: {
            schedulerName: { required: 'Scheduler name is required.', pattern: 'Scheduler name is required.' },
            runDate: { required: 'Date is required.', matDatepickerMin: 'Date is in the past. Pick today or a later date to save.' },
            runTime: {
                required: 'Time is required.', pattern: 'Time is required.',
                invalidTime: 'Enter a valid time in 24-hour format (HH:mm).', pastDateTime: 'Time is in the past. Pick a future time to save.'
            },
            cronExpression: {
                required: 'CRON expression is required.', pattern: 'CRON expression is required.',
                invalidCron: 'Enter a valid 5-field CRON: min hour day month dayOfWeek (supports *, ranges, lists and steps).'
            }
        } as Record<string, Record<string, string>>,
        jobExecutions: {
            title: 'Job Executions',
            dateLabel: 'Date',
            buildsTab: 'Builds',
            workflowsTab: 'Workflows',
            reportTab: 'Report',
            dependencyGraphTab: 'Dependency Graph',
            noExecutions: 'No scheduled job executions on this date.',
            noBuilds: 'No builds were triggered by this run.',
            noWorkflows: 'No workflows available.',
            noReport: 'Report is not available yet.',
            noDependencyGraph: 'Dependency graph is not available yet.',
            graphLoadFailed: 'Unable to display the dependency graph.',
            cancelRunTooltip: 'Cancel this scheduled run',
            refreshWorkflowsTooltip: 'Refresh workflows'
        }
    }
};
